import React from 'react';
import { Linkedin, Instagram, MessageCircle, Apple, Play } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
const WHATSAPP_URL = 'https://wa.me/77010346443?text=%D1%85%D0%BE%D1%87%D1%83%20%D0%B4%D0%B5%D0%BC%D0%BE%20Meelo';
const socialLinks = [{
  icon: Linkedin,
  href: '#',
  label: 'LinkedIn'
}, {
  icon: MessageCircle,
  href: WHATSAPP_URL,
  label: 'WhatsApp'
}, {
  icon: Instagram,
  href: '#',
  label: 'Instagram'
}, {
  icon: Apple,
  href: '#',
  label: 'App Store'
}, {
  icon: Play,
  href: '#',
  label: 'Google Play'
}];
export function Footer() {
  const {
    t
  } = useLanguage();
  const pageLinks = [{
    label: t('footer.home'),
    href: '#'
  }, {
    label: t('nav.about'),
    href: '#what-is-meelo'
  }, {
    label: t('nav.solutions'),
    href: '#solutions'
  }];
  const infoLinks = [{
    label: t('footer.privacy'),
    href: '#/privacy'
  }, {
    label: t('footer.terms'),
    href: '#/privacy'
  }, {
    label: t('footer.offer'),
    href: '#/offer'
  }, {
    label: t('footer.refund'),
    href: '#/refund'
  }, {
    label: t('footer.delivery'),
    href: '#/delivery'
  }, {
    label: t('footer.replacement'),
    href: '#/replacement'
  }];
  return <footer className="bg-[#F0EBF8] py-10 px-4 sm:px-6 lg:px-8" data-id="element-10">
      <div className="max-w-6xl mx-auto" data-id="element-11">
        {/* Main card */}
        <div className="bg-white rounded-3xl shadow-sm border border-gray-100 px-8 py-10 md:px-12 md:py-12" data-id="element-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8" data-id="element-13">
            {/* Left — Logo + tagline + contact + socials */}
            <div className="flex flex-col gap-4" data-id="element-14">
              <a href="#" data-id="element-15">
                <img src="https://cdn.magicpatterns.com/uploads/k1HQQhYUAYkCqHQP8zEE8y/meelo_logo_transparent.png" alt="Meelo" className="h-16 w-auto" data-id="element-16" />
              </a>
              <p className="text-sm text-gray-500 leading-relaxed max-w-[220px]" data-id="element-17">
                {t('footer.tagline')}
              </p>
              <div className="flex flex-col gap-1.5" data-id="element-18">
                <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="text-sm font-semibold text-[#7C4DFF] hover:text-[#651FFF] transition-colors" data-id="element-19">
                  {t('nav.phone')}
                </a>
                <a href={`mailto:${t('footer.email')}`} className="text-sm font-semibold text-[#7C4DFF] hover:text-[#651FFF] transition-colors" data-id="element-20">
                  {t('footer.email')}
                </a>
                <p className="text-sm text-gray-500 leading-relaxed max-w-[240px]" data-id="element-21">
                  {t('footer.address')}
                </p>
              </div>
              <div className="flex items-center gap-2 mt-1" data-id="element-22">
                {socialLinks.map(({
                icon: Icon,
                href,
                label
              }) => <a key={label} href={href} target={href !== '#' ? '_blank' : undefined} rel="noopener noreferrer" aria-label={label} className="w-9 h-9 rounded-full bg-[#EDE7F6] flex items-center justify-center text-[#7C4DFF] hover:bg-[#7C4DFF] hover:text-white transition-all" data-id="element-23">
                    <Icon size={16} strokeWidth={1.8} data-id="element-24" />
                  </a>)}
              </div>
            </div>

            {/* Middle — Pages */}
            <div data-id="element-25">
              <p className="text-xs font-bold tracking-widest uppercase text-gray-400 mb-5" data-id="element-26">
                {t('footer.pages')}
              </p>
              <ul className="space-y-3" data-id="element-27">
                {pageLinks.map(({
                label,
                href
              }) => <li key={label} data-id="element-28">
                    <a href={href} className="text-sm text-gray-600 hover:text-[#7C4DFF] transition-colors" data-id="element-29">
                      {label}
                    </a>
                  </li>)}
              </ul>
            </div>

            {/* Right — Info */}
            <div data-id="element-30">
              <p className="text-xs font-bold tracking-widest uppercase text-gray-400 mb-5" data-id="element-31">
                {t('footer.info')}
              </p>
              <ul className="space-y-3" data-id="element-32">
                {infoLinks.map(({
                label,
                href
              }) => <li key={label} data-id="element-33">
                    <a href={href} className="text-sm text-gray-600 hover:text-[#7C4DFF] transition-colors" data-id="element-34">
                      {label}
                    </a>
                  </li>)}
              </ul>
            </div>
          </div>

          {/* Divider + copyright */}
          <div className="border-t border-gray-100 mt-10 pt-6 text-center text-xs text-gray-400" data-id="element-35">
            {t('footer.copyright')}
          </div>
        </div>
      </div>
    </footer>;
}